var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('div',{staticClass:"list-tt"},[_vm._v("格局旺衰")]),_vm._v(" "),_c('div',{staticClass:"list-info",staticStyle:{"display":"block"}},[_c('div',{staticClass:"panci",domProps:{"innerHTML":_vm._s(_vm.panci)}}),_vm._v(" "),_c('div',{staticClass:"shen",domProps:{"innerHTML":_vm._s(_vm.shen)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60a28cf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/geju.vue
// module id = null
// module chunks = 